import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from "@angular/common";
import { AssetClassRetailBuildingModel } from 'src/app/core/comparable/_models/asset-class-retail-building.model';
import { LayoutUtilsService, MessageType, TypesUtilsService } from 'src/app/core/_base/crud';
import { BehaviorSubject, combineLatest, Observable, of, Subject, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/core/reducers';
import { selectAssetClassRetailBuildingActionLoading } from 'src/app/core/comparable/_selectors/asset-class-retail-building.selectors';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { AllCitiesRequested, AllCountriesRequested, CityModel, CountryModel, selectAllCountries } from 'src/app/core/admin';
import { each} from 'lodash';
import { map, startWith, take, takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AllCoordinateReferenceSystemsRequested, AllFoundationTypesRequested, AllGradesRequested, AllHandoverStandardsRequested, AllStateRepairsRequested, AllUnitAreaMeasurementsRequested, CoordinateReferenceSystem, FoundationType, Grade, HandoverStandard, selectAllCoordinateReferenceSystems, selectAllFoundationTypes, selectAllGrades, selectAllHandoverStandards, selectAllStateRepairs, selectAllUnitAreaMeasurements, StateRepair } from 'src/app/core/linked-tables';
import { AssetClassConsiderationModel, AssetClassLandAreaComponentModel, AssetClassLandAreaModel, AssetClassTenureModel } from 'src/app/core/asset_class';
import { SubTypeCategoryModel } from 'src/app/core/linked-tables/_models/sub-type-category.model';
import { SubCategoryModel } from 'src/app/core/linked-tables/_models/sub-category.model';
import { AllSubTypeCategorysRequested } from 'src/app/core/linked-tables/_actions/sub-type-category.actions';
import { selectAllSubTypeCategorys } from 'src/app/core/linked-tables/_selectors/sub-type-category.selectors';
import { AllSubCategorysRequested } from 'src/app/core/linked-tables/_actions/sub-category.actions';
import { selectAllSubCategorys } from 'src/app/core/linked-tables/_selectors/sub-category.selectors';
import { LandParcelMapComponent } from '../../../shared_components/land-parcel/land-parcel-map/land-parcel-map.component';
import { ExternalAspectsComponent } from '../../../shared_components/external-aspects/external-aspects.component';
import { AccommodationLayoutTableComponent } from '../../../shared_components/accommodation-layout-table/accommodation-layout-table.component';
import { ServicesAndInfrastructuresComponent } from '../../../shared_components/services-and-infrastructures/services-and-infrastructures.component';
import { AcGroundsComponent } from '../../../shared_components/ac-grounds/ac-grounds.component';
import { AssetClassRetailBuildingOnServerCreated, AssetClassRetailBuildingOnServerUpdated } from 'src/app/core/comparable/_actions/asset-class-retail-building.actions';
import { LandAreaListComponent } from '../../../shared_components/land-parcel/land-area/land-area-list/land-area-list.component';
import { AcSource, AssetClassSizeModel, AssetClassTenure } from 'src/app/core/comparable';
import { AcDocumentUploadComponent } from '../../../shared_components/ac-document-upload/ac-document-upload.component';
import { TenureConsiderationListComponent } from '../../../shared_components/land-parcel/tenure-consideration/tenure-consideration-list/tenure-consideration-list.component';
import { __spreadArrays } from 'tslib';
import { UploadFileComponent } from '../../../shared_components/upload-file/upload-file.component';
import { ParcelConsiderationsComponent } from '../../../shared_components/parcel-considerations/parcel-considerations.component';
import { InternalAspectsComponent } from '../../../shared_components/internal-aspects/internal-aspects.component';
import { ComparableLocationComponent } from 'src/app/components/location/comparable-location/comparable-location.component';
import { ConsiderationAndSourceComponent } from '../../_sub/consideration-and-source/consideration-and-source.component';
import { TabHeader } from '../../../shared_components/tab-header/tab-header.component';
import { environment } from 'src/environments/environment';
import {v4 as uuidv4} from 'uuid'
import { AssetClassSize } from 'src/app/core/v2/types';
import { EsgIndicatorsComponent } from '../../../mad_shared/esg-indicators/esg-indicators.component';
import { currentUser } from 'src/app/core/mad-auth/mad-auth.store';
import { EsgIndicator } from 'src/app/core/v2/state/esg-indicator/type';
import { CoordinatePoint } from 'src/app/core/v3/coordinate-points';
import { LandArea, mapAssetClassLandAreaComponentToLandArea, mapLandAreaToAssetClassLandAreaComponent } from 'src/app/core/v3/land-area';
import { createParcelIdentificationFormGroup, ParcelIdentificationFormGroup } from 'src/app/components/parcel-identification/form-group';
import { LandAreaFormGroup } from 'src/app/components/land-areas/form-group';
import { formControlValueChanges } from 'src/app/core/v2/utils';
import { LocationInfo } from 'src/app/core/v3/location';

@Component({
  selector: 'kt-retail-building-edit',
  templateUrl: './retail-building-edit.component.html',
  styleUrls: ['./retail-building-edit.component.scss', '../../complex-btn.scss']
})
export class RetailBuildingEditComponent implements OnInit, OnDestroy {
  @ViewChild('search', {static: true})
  public searchElementRef: ElementRef;

  @ViewChild(ComparableLocationComponent, {static: false}) 
  mapLocationComponent: ComparableLocationComponent;
  locationInfo: LocationInfo | null = null;

  @ViewChild(LandParcelMapComponent, {static: false}) 
  landParcelMapComponent: LandParcelMapComponent;

  @ViewChild(LandAreaListComponent, {static: false})
  landAreaListComponent: LandAreaListComponent;

  @ViewChild(AccommodationLayoutTableComponent, {static: false})
  accommodationLayoutTable: AccommodationLayoutTableComponent;

  @ViewChild(ServicesAndInfrastructuresComponent, {static: true})
  servicesAndInfraComponent: ServicesAndInfrastructuresComponent;

  @ViewChild(ExternalAspectsComponent, {static: false})
  externalAspectComponent: ExternalAspectsComponent;

  @ViewChild(InternalAspectsComponent, {static: false})
  internalAspectComponent: InternalAspectsComponent;

  @ViewChild(AcGroundsComponent, {static: true})
  acGroundsComponent: AcGroundsComponent;

  @ViewChild(AcDocumentUploadComponent, {static: false})
  acDocumentUploadComponent: AcDocumentUploadComponent;

  @ViewChild(EsgIndicatorsComponent, {static: false})
  esgIndicatorComponent: EsgIndicatorsComponent


  @ViewChild('simple')
  public uploadFileComponent: UploadFileComponent;

  @ViewChild(ConsiderationAndSourceComponent, {static: false})
  considerationAndSourceComponent: ConsiderationAndSourceComponent;

  loading$: Observable<boolean>;

  acRetailBuilding: AssetClassRetailBuildingModel;

  centerLat = null;
  centerLng = null;

  formGroup: UntypedFormGroup;
  hasFormErrors: boolean = false;
  formErrorMsg$: BehaviorSubject<string> = new BehaviorSubject(null);
  formSelectionCtrl: UntypedFormControl = new UntypedFormControl();
  isComplexForm: boolean = false;

  allCountries: CountryModel[] = [];
  cityOfCountry: CityModel[] = [];
  grades: Grade[] = [];
  coordinateReferenceSystems: CoordinateReferenceSystem[] = [];
  subTypeCategories: SubTypeCategoryModel[] = [];
  subCategories: SubCategoryModel[] = [];
  filteredSubCategories: SubCategoryModel[] = [];
  stateOfRepairs: StateRepair[] = [];
  handoverStandards: HandoverStandard[] = [];
  foundationTypes: FoundationType[] = [];
  aboveFloor$: BehaviorSubject<number> = new BehaviorSubject(0);
  belowFloor$: BehaviorSubject<number> = new BehaviorSubject(0);
  floors$: Observable<number[]>; 

  tenuresSubject = new BehaviorSubject<AssetClassTenure[]>([])
  sizesSubject = new BehaviorSubject<AssetClassSizeModel[]>([]);
  sizes$ = combineLatest([ 
    this.store.select(selectAllUnitAreaMeasurements),
    this.sizesSubject.asObservable()
  ]).pipe(
    map(([unitAreaMeasurements, sizes]) => {
      const items: AssetClassSize[] = sizes.map(size => ({
        id: size.id,
        uid: size.uid,
        size: size.size,
        standardMeasurementName: size.standard_measurement_name,
        unitAreaMeasurementAcronym: unitAreaMeasurements.find(item => item.id === size.unit_of_area_measurement_id)?.acronym
      }))
      return items
    })
  )
  sourceSubject = new BehaviorSubject<AcSource>(new AcSource());
  considerationListSubject = new BehaviorSubject<AssetClassConsiderationModel[]>([]);

  showTitleRequiredError$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  protected _onDestroy = new Subject<void>();
  private subscriptions: Subscription[] = [];

  private _hasParcelInfo$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public hasParcelInfo$: Observable<boolean> = this._hasParcelInfo$.asObservable();
  public considerationError$ = new BehaviorSubject(false);
  selectedTab = 0;
  selectedtabchange: BehaviorSubject<number> = new BehaviorSubject(0);
  selectedtabchange$: Observable<number> = this.selectedtabchange.asObservable();
  tabHeaders: TabHeader[] = [
    {label: 'Location & land identification', disabled: of(false)},
    {label: 'Property information', disabled: of(false)},
    {label: 'ESG indicators', disabled: of(false)},
    {label: 'Lease & sale information', disabled: of(false)},
    {label: 'Pictures & documents', disabled: of(false)},
  ];
  location_tab_items = ['land_parcel_name','coordinate_reference_system_id'];
  error:any = {
    msg: ' Missing Fields in total:',
    fields: []
  }
  markerInfo: {lat: number, lng: number, isShow: boolean} = {lat: undefined, lng: undefined, isShow: false};
  onMarkerChange(event) {
    if (event == null)  {
      return;
    }
    this.markerInfo = {
      lat: event.lat,
      lng: event.lng,
      isShow: event.isShown
    }
  }

  timezoneOffset: string | null
  onTimezoneChange(offset: string) {
    this.timezoneOffset = offset
  }

  private readonly _currentUser$ = this.store.select(currentUser)
  userUnitOfMeasurementId$ = this._currentUser$.pipe(
    map(user => {
      if (!user) return null 
      return user.settings.unit_of_measurement_id
    })
  )
  private validateClicked = false
  private _formState$ = new BehaviorSubject({
    map_location: {
      invalid: undefined,
      fields: 0
    },
    parcel: {
      invalid: undefined,
      fields: 0
    },
    about_property: {
      invalid: undefined,
      fields: 0
    },
    external_aspect: {
      invalid: undefined,
      fields: 0
    },
    internal_aspect: {
      invalid: undefined,
      fields: 0
    },
    grounds: {
      invalid: undefined,
      fields: 0
    },
    size: {
      invalid: undefined,
      fields: 0
    },
    considerations: {
      invalid: undefined,
      fields: 0
    },
    pictures: {
      invalid: undefined,
      fields: 0
    }
  })
  formTabHeaders$ = this._formState$.asObservable().pipe(
    map(state => {
      let locationState = 'required'
      let locationStateFields = 0
      if (state.map_location.invalid || state.parcel.invalid) {
        locationState = 'error'
        locationStateFields = state.map_location.fields + state.parcel.fields
      } else if (state.map_location.invalid == false && state.parcel.invalid == false) {
        locationState = 'complete'
      }

      let propertyState = 'required'
      let propertyStateFields = 0
      if (
        state.about_property.invalid || 
        state.external_aspect.invalid || 
        state.internal_aspect.invalid || 
        state.grounds.invalid ||
        state.size.invalid
      ) {
        propertyState = 'error'
        propertyStateFields = 
          state.about_property.fields +
          state.external_aspect.fields +
          state.internal_aspect.fields + 
          state.grounds.fields +
          state.size.fields;
      } else if (
        state.about_property.invalid == false &&
        state.external_aspect.invalid == false &&
        state.internal_aspect.invalid == false &&
        state.grounds.invalid == false &&
        state.size.invalid == false
      ) {
        propertyState = 'complete'
      }

      let considerationState = 'required'
      let considerationFields = 0
      if (
        state.considerations.invalid
      ) {
        considerationState = 'error'
        considerationFields = state.considerations.fields
      } else if (
        state.considerations.invalid == false
      ) {
        considerationState = 'complete'
      }

      let picturesState = 'required'
      let picturesFields = 0
      if (
        state.pictures.invalid
      ) {
        picturesState = 'error'
        picturesFields = state.pictures.fields
      } else if (
        state.pictures.invalid == false
      ) {
        picturesState = 'complete'
      }

      return [
        {
          label: 'Location & Land Identification',
          state: locationState,
          requiredFields: locationStateFields
        },
        {
          label: 'Property Information',
          state: propertyState,
          requiredFields: propertyStateFields
        },
        {
          label: 'ESG Indicators',
          state: 'default',
          requiredFields: 0
        },
        {
          label: 'Lease & Sale Information',
          state: considerationState,
          requiredFields: considerationFields
        },
        {
          label: 'Pictures & Documents',
          state: 'default',
          requiredFields: 0
        }
      ]
    })
  )

  private _points$ = new BehaviorSubject<CoordinatePoint[]>([])
  coordinatePoints$ = this._points$.asObservable()
  private _landAreas$ = new BehaviorSubject<LandArea[]>([])
  landAreas$ = this._landAreas$.asObservable()
  landAreaComponentListSubject = new BehaviorSubject<AssetClassLandAreaComponentModel[]>([])

  constructor(
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private layoutUtilsService: LayoutUtilsService,
    private typesUtilsService: TypesUtilsService,
    private store: Store<AppState>,
    private formBuilder: UntypedFormBuilder,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.landAreas$.pipe(
      takeUntil(this._onDestroy),
      map(items => items.map(item => mapLandAreaToAssetClassLandAreaComponent(item)))
    ).subscribe(items => {
      this.landAreaComponentListSubject.next(items)
    })
    this.floors$ = combineLatest([
      this.aboveFloor$,
      this.belowFloor$
    ]).pipe(
      map(([above, below]) => {
        const l = -1 * (below ?? 0);
        const h = above ?? 0;
        const numbers: number[] = [];
        for (let i = l; i <= h; i++) {
          numbers.push(i);
        }
        return numbers;
      })
    )
    const routeSubscription = this.activatedRoute.params.subscribe(params => {
      const id = params.retailbuilding_id;
      if (id && id > 0) {
        this.activatedRoute.data.subscribe(data => {
          const res = data.data;
          this.acRetailBuilding = res.data;
          this.isComplexForm = this.acRetailBuilding.formType == 1;
          this._points$.next(this.acRetailBuilding.points.map(item => ({latitude: Number(item.lat), longitude: Number(item.lng)})))
          this._landAreas$.next(this.acRetailBuilding.landAreaComponents.map(item => mapAssetClassLandAreaComponentToLandArea(item)))
          const deepCopiedSizes = _deepCopy(this.acRetailBuilding.sizes)
            .map(size => {
              size.uid = uuidv4()
              return size
            })
          const deepCopiedTenures = _deepCopy(this.acRetailBuilding.tenures)
            .map(tenure => {
              const rentSizeUuid = deepCopiedSizes.find(size => size.id === tenure.rent_size_id)?.uid
              const expensesSizeUuid = deepCopiedSizes.find(size => size.id === tenure.expenses_size_id)?.uid
              tenure.rent_size_uid = rentSizeUuid
              tenure.expenses_size_uid = expensesSizeUuid
              return tenure
            })
          this.tenuresSubject.next(deepCopiedTenures)
          this.sizesSubject.next(deepCopiedSizes);
          this.sourceSubject.next(this.acRetailBuilding.source);
          this._setLocationInfo();
          this.markerInfo = {
            lat: this.acRetailBuilding.locationData.latitude,
            lng: this.acRetailBuilding.locationData.longitude,
            isShow: true
          }
          this._createForm();
        })
      } else {
        this.acRetailBuilding = new AssetClassRetailBuildingModel();
        this.acRetailBuilding.clear();
        this._points$.next(this.acRetailBuilding.points.map(item => ({latitude: Number(item.lat), longitude: Number(item.lng)})))
        this._landAreas$.next(this.acRetailBuilding.landAreaComponents.map(item => mapAssetClassLandAreaComponentToLandArea(item)))
        this.sizesSubject.next(this.acRetailBuilding.sizes);
        this.sourceSubject.next(this.acRetailBuilding.source);
        this._createForm();
      }
    })
    this.subscriptions.push(routeSubscription);

    this.loading$ = this.store.pipe(select(selectAssetClassRetailBuildingActionLoading));

    // Linked Tables
    this.store.dispatch(new AllUnitAreaMeasurementsRequested())
    this.store.dispatch(new AllCountriesRequested());
    this.store.dispatch(new AllCitiesRequested());
    const countrySubscription = this.store.pipe(select(selectAllCountries)).subscribe((res: CountryModel[]) => {
        this.allCountries = [];
        each(res, (_country: CountryModel) => {
            this.allCountries.push(_country);
        });
    });
    this.subscriptions.push(countrySubscription);

    this.store.dispatch(new AllGradesRequested());
    const gradeSubscription = this.store.pipe(
        select(selectAllGrades))
        .subscribe(res => {
            this.grades = [];
            if (res) {
                this.grades = res;
            }
        });
    this.subscriptions.push(gradeSubscription);

    this.store.dispatch(new AllCoordinateReferenceSystemsRequested());
    const coordinateReferenceSystemsSubscription = this.store.pipe(
        select(selectAllCoordinateReferenceSystems),
    ).subscribe(res => {
        this.coordinateReferenceSystems = [];
        if (res) {
            this.coordinateReferenceSystems = res;
        }
    });
    this.subscriptions.push(coordinateReferenceSystemsSubscription);

    this.store.dispatch(new AllSubTypeCategorysRequested());
    const subTypeSub = this.store.pipe(
      select(selectAllSubTypeCategorys)
    ).subscribe(res => {
      this.subTypeCategories = res ? res.filter(item => item.property_sub_type_id == 11) : [];
    });
    this.subscriptions.push(subTypeSub);

    this.store.dispatch(new AllSubCategorysRequested());
    const subCatSub = this.store.select(selectAllSubCategorys)
      .subscribe(res => {
        this.subCategories = res ? res : [];
        this.filteredSubCategories = this._filterSubCategories(this.acRetailBuilding.sub_type_category_id);
      });
    this.subscriptions.push(subCatSub);

    this.store.dispatch(new AllStateRepairsRequested())
    const stateRepairSub = this.store.select(selectAllStateRepairs)
      .subscribe(res => {
        this.stateOfRepairs = res ? res : [];
      });
    this.subscriptions.push(stateRepairSub);

    this.store.dispatch(new AllHandoverStandardsRequested())
    const handoverSub = this.store.select(selectAllHandoverStandards)
      .subscribe(res => {
        this.handoverStandards = res ? res : []
      });
    this.subscriptions.push(handoverSub);

    this.store.dispatch(new AllFoundationTypesRequested())
    const foundationSub = this.store.select(selectAllFoundationTypes)
      .subscribe(res => {
        this.foundationTypes = res ? res : []
      });
    this.subscriptions.push(foundationSub);
  }
  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  /**
   * Actions 
   */
  back() {
    this.location.back();
  }
  onSubmit(isComplete: boolean) {
    this.validateClicked = isComplete
    let errorFields = [];
    this.hasFormErrors = false;
    this.showTitleRequiredError$.next(false);
    this.considerationError$.next(false);
    if (isComplete == false || this.isComplexForm == false) {
      this._changeValidation(isComplete);
    }

    let formState = this._formState$.getValue()
    if (this.mapLocationComponent) {
      if (isComplete && this.mapLocationComponent.validate()) {
        this.hasFormErrors = true;
        errorFields = [...errorFields, ...this.mapLocationComponent.errorFields];
        formState = {
          ...formState,
          map_location: {
            invalid: true,
            fields: this.mapLocationComponent.errorFields.length
          }
        }
      } else {
        formState = {
          ...formState,
          map_location: {
            invalid: false,
            fields: 0
          }
        }
      }
    } else {
      formState = {
        ...formState,
        map_location: {
          invalid: false,
          fields: 0
        }
      }
    }
    const controls = this.formGroup.controls;
    let parcelFormErrorFields = []
    if (this.formGroup.invalid && controls.add_info_on_land.value) {
      Object.keys(controls).filter(cName => this.location_tab_items.includes(cName)).forEach(cName => {
        if (!controls[cName].valid) {
          this.hasFormErrors = true;
          errorFields = [...errorFields, cName];
          parcelFormErrorFields = [...parcelFormErrorFields, cName]
          this.formErrorMsg$.next(`${cName} has error`);
        }
        controls[cName].markAsTouched();
      });
      formState = {
        ...formState,
        parcel: {
          invalid: true,
          fields: parcelFormErrorFields.length
        }
      }
    } else {
      formState = {
        ...formState,
        parcel: {
          fields: 0,
          invalid: false
        }
      }
    }

    let formFieldErrors = []
    if (isComplete && this.formGroup.invalid) {
      Object.keys(controls).filter(cName => !this.location_tab_items.includes(cName)).forEach(cName => {
        if (!controls[cName].valid) {
          errorFields = [...errorFields, cName];
          formFieldErrors = [...formFieldErrors, cName]
          this.formErrorMsg$.next(`${cName} has error`);
        }
        controls[cName].markAsTouched();
      });
      this.hasFormErrors = true;
      formState = {
        ...formState,
        about_property: {
          invalid: true,
          fields: formFieldErrors.length
        }
      }
    } else {
      formState = {
        ...formState,
        about_property: {
          fields: 0,
          invalid: false
        }
      }
    }
    if (this.externalAspectComponent) {
      if (isComplete && this.externalAspectComponent.validate()) {
        this.hasFormErrors = true;
        errorFields = [...errorFields, ...this.externalAspectComponent.errorFields];
        formState = {...formState, external_aspect: {
          fields: this.externalAspectComponent.errorFields.length,
          invalid: true
        }}
      } else {
        formState = {...formState, external_aspect: {
          fields: 0,
          invalid: false
        }}
      }
    } else {
      formState = {...formState, external_aspect: {
        fields: 0,
        invalid: false
      }}
    }

    if (this.internalAspectComponent) {
      if (isComplete && this.internalAspectComponent.validate()) {
        this.hasFormErrors = true;
        errorFields = [...errorFields, ...this.internalAspectComponent.errorFields];
        formState = {...formState, internal_aspect: {
          fields: this.internalAspectComponent.errorFields.length,
          invalid: true
        }}
      } else {
        formState = {...formState, internal_aspect: {
          fields: 0,
          invalid: false
        }}
      }
    } else {
      formState = {...formState, internal_aspect: {
        fields: 0,
        invalid: false
      }}
    }

    if (isComplete && this.acGroundsComponent.validate()) {
      this.hasFormErrors = true;
      errorFields = [...errorFields, ...this.acGroundsComponent.errorFields];
      formState = {...formState, grounds: {
        fields: this.acGroundsComponent.errorFields.length,
        invalid: true
      }}
      if (this.acGroundsComponent.errorFields.length == 0) {
        errorFields = [...errorFields, 'grounds'];
        formState = {...formState, grounds: {
          fields: 1,
          invalid: true
        }}
      }
    } else {
      formState = {...formState, grounds: {
        fields: 0,
        invalid: false
      }}
    }

    if (isComplete && this.sizesSubject.value.length == 0) {
      this.hasFormErrors = true;
      errorFields = [...errorFields, 'size'];
      formState = {...formState, size: {
        fields: 1,
        invalid: true
      }}
    } else {
      formState = {...formState, size: {
        fields: 0,
        invalid: false
      }}
    }

    // Consideration
    if (isComplete && !this.considerationAndSourceComponent.validate()) {
      this.hasFormErrors = true;
      this.considerationError$.next(true);
      errorFields = [...errorFields, 'consideration'];
      formState = {
        ...formState,
        considerations: {
          invalid: true,
          fields: 1
        }
      }
    } else {
      formState = {
        ...formState,
        considerations: {
          invalid: false,
          fields: 0
        }
      }
    }

    if (isComplete && this.uploadFileComponent.uploadFiles.length == 0) {
      // this.hasFormErrors = true;
      // errorFields = [...errorFields, 'pic'];
      // formState = {
      //   ...formState,
      //   pictures: {
      //     invalid: true,
      //     fields: 1
      //   }
      // }
    } else {
      let hasError = false
      const uploadedFiles = this.uploadFileComponent.uploadFiles;
      uploadedFiles.forEach(file => {
        if (file.title === null || file.title === '') {
          hasError = true
          this.hasFormErrors = true;
          this.showTitleRequiredError$.next(true);
          errorFields = [...errorFields, 'pic'];
        }
      })
      if (hasError) {
        formState = {
          ...formState,
          pictures: {
            invalid: true,
            fields: 1
          }
        }
      } else {
        formState = {
          ...formState,
          pictures: {
            invalid: false,
            fields: 0
          }
        }
      }
    }
    let esgIndicatorValues: EsgIndicator | null = null
    if (this.esgIndicatorComponent) {
      const esgIndicatorResult = this.esgIndicatorComponent.submit(!isComplete)
      if (esgIndicatorResult.type === 'success') {
        esgIndicatorValues = esgIndicatorResult.values
      } else if (esgIndicatorResult.type === 'error') {
        this.hasFormErrors = true
        errorFields = [...errorFields, esgIndicatorResult.errors]
      }
    }
    this._formState$.next(formState)
    if (this.hasFormErrors) {
      this.error.fields = errorFields;
      this.layoutUtilsService.showFormError()
      return;
    }

    this.landAreaListComponent && this.landAreaListComponent.updateValue();
    const _ac = this._preparteAssetClass(isComplete, esgIndicatorValues);
    if (_ac.id) {
      this._updateAssetClass(_ac);
    } else {
      this._createAssetClass(_ac);
    }
  }
  onHasFormErrorsChange(obj: {hasFormErrors: boolean}) {
    this.hasFormErrors = obj.hasFormErrors;
  }

  /**
   * Template functions
   */
  getComponentTitle(): string {
    if (this.acRetailBuilding && this.acRetailBuilding.id) {
      return `Edit Retail Building "${this.acRetailBuilding.ref_num}"`
    }
    return 'Add Retail Building'
  }

  /**
   * Methods
   */
  private _changeValidation(isComplete: boolean) {
    // const controls = this.formGroup.controls;
    // const mustCnames = ['country_id', 'city_id', 'location_grade_id', 'address', 'sub_type_category_id', 
    //   'sub_category_id', 'property_grade_id', 'completion_year', 'state_of_repair_id', 'handover_standard_id',
    //   'above_floors'];
    // Object.keys(controls).forEach(cName => {
    //   if (isComplete && mustCnames.filter(item => item == cName).length == 1) {
    //     return;
    //   }
    //   controls[cName].clearValidators();
    //   controls[cName].updateValueAndValidity();
    // });
    if (this.externalAspectComponent) {
      this.externalAspectComponent.changeValidation();
    }
    if (this.internalAspectComponent) {
      this.internalAspectComponent.changeValidation();
    }
  }
  private _preparteAssetClass(isComplete: boolean, esgIndicator: EsgIndicator): AssetClassRetailBuildingModel {
    const _ac = new AssetClassRetailBuildingModel();
    _ac.clear();
    _ac.id = this.acRetailBuilding.id;
    _ac.status = isComplete ? 1 : 0;
    _ac.formType = this.formSelectionCtrl.value;
    _ac.esgIndicator = esgIndicator

    const controls = this.formGroup.controls;

    if (this.mapLocationComponent) {
      // Keep fields the location component does not capture (address, grade, land
      // boundary…) so they survive a save from this form.
      _ac.locationData = { ..._ac.locationData, ...this.mapLocationComponent.getData() };
    }

    const parcelIdentificationForm = controls.parcel_identification as ParcelIdentificationFormGroup
    const landAreaForm = parcelIdentificationForm.controls.land_area as LandAreaFormGroup
    const landArea = new AssetClassLandAreaModel()
    landArea.clear()
    landArea.id = this.acRetailBuilding.landArea.id
    landArea.planning_status_id = landAreaForm.controls.planning_status_id.value
    landArea.qos_degradation_id = landAreaForm.controls.qos_degradation_id.value
    landArea.env_considerations = landAreaForm.controls.env_considerations.value
    landArea.other_considerations = landAreaForm.controls.other_considerations.value
    _ac.add_info_on_land = parcelIdentificationForm.controls.add_info_on_land.value;
    _ac.land_parcel_name = parcelIdentificationForm.controls.land_parcel_name.value;
    _ac.coordinate_reference_system_id = parcelIdentificationForm.controls.coordinate_reference_system_id.value;
    _ac.boundary_type_id = parcelIdentificationForm.controls.boundary_type.value
    _ac.points = this._points$.value.map(item => ({lat: item.latitude, lng: item.longitude}));
    _ac.landArea = landArea;
    _ac.landAreaComponents = this._landAreas$.value.map(item => mapLandAreaToAssetClassLandAreaComponent(item)) 

    _ac.sub_type_category_id = controls.sub_type_category_id.value;
    _ac.sub_category_id = controls.sub_category_id.value;
    _ac.property_grade_id = controls.property_grade_id.value;
    _ac.general_desc = controls.general_desc.value;
    _ac.completion_year = controls.completion_year.value;
    _ac.apprx_year_extended = controls.apprx_year_extended.value;
    _ac.state_of_repair_id = controls.state_of_repair_id.value;
    _ac.handover_standard_id = controls.handover_standard_id.value;
    _ac.foundation_type_id = controls.foundation_type_id.value;
    _ac.above_floors = controls.above_floors.value;
    _ac.below_floors = controls.below_floors.value;
    _ac.construction_desc = controls.construction_desc.value;
    _ac.has_parcel_consideration = controls.has_parcel_consideration.value;
    _ac.land_comment = controls.land_comment.value;
    _ac.accommodation = this.accommodationLayoutTable ? {...this.accommodationLayoutTable.getData(), id: this.acRetailBuilding.accommodation.id} : {id: this.acRetailBuilding.accommodation.id, data: null, others: []};
    _ac.boundary_type_id = controls.boundary_type_id.value;

    _ac.serviceAndInfraData = this.servicesAndInfraComponent.getdata();

    if (this.externalAspectComponent) {
      _ac.externalAspectData = this.externalAspectComponent.getData();
    }

    if (this.internalAspectComponent) {
      _ac.internalAspectData = this.internalAspectComponent.getData();
    }

    _ac.grounds = {...this.acGroundsComponent.getData(), id: this.acRetailBuilding.grounds.id};

    this.uploadFileComponent.res$.pipe(take(1)).subscribe(value => {
        if (value) {
            _ac.picture = value.success;
        }
    })
    _ac.sizes = this.sizesSubject.value;
    _ac.source = this.sourceSubject.value;
    _ac.tenures = this.considerationAndSourceComponent ? this.considerationAndSourceComponent.getData() : [];
    if (this.acDocumentUploadComponent) {
      _ac.documents = this.acDocumentUploadComponent.getDocuments();
    }
    return _ac;

  }
  private _createForm() {
    this.formSelectionCtrl.setValue(this.acRetailBuilding.formType);
    this.formSelectionCtrl.updateValueAndValidity();
    const formSelectionSubscription = this.formSelectionCtrl.valueChanges.subscribe(val => {
      if (val == 1) {
        this.isComplexForm = true;
      } else {
        this.isComplexForm = false;
      }
      if (this.formGroup) {
        this.ngZone.onStable.pipe(take(1)).subscribe(() => {
          if (this.validateClicked) {
            this.onSubmit(true)
          }
        })
      }
    });
    this.subscriptions.push(formSelectionSubscription);

    this.formGroup = this.formBuilder.group({
      add_info_on_land: [this.acRetailBuilding.add_info_on_land],
      land_parcel_name: [this.acRetailBuilding.land_parcel_name],
      coordinate_reference_system_id: [this.acRetailBuilding.coordinate_reference_system_id],

      sub_type_category_id: [this.acRetailBuilding.sub_type_category_id],
      sub_category_id: [this.acRetailBuilding.sub_category_id],
      property_grade_id: [this.acRetailBuilding.property_grade_id],
      general_desc: [this.acRetailBuilding.general_desc],
      completion_year: [this.acRetailBuilding.completion_year],
      apprx_year_extended: [this.acRetailBuilding.apprx_year_extended],
      state_of_repair_id: [this.acRetailBuilding.state_of_repair_id],
      handover_standard_id: [this.acRetailBuilding.handover_standard_id],
      foundation_type_id: [this.acRetailBuilding.foundation_type_id],
      above_floors: [this.acRetailBuilding.above_floors],
      below_floors: [this.acRetailBuilding.below_floors],
      construction_desc: [this.acRetailBuilding.construction_desc],

      has_parcel_consideration: [this.acRetailBuilding.has_parcel_consideration],
      land_comment: [this.acRetailBuilding.land_comment],
      boundary_type_id: [this.acRetailBuilding.boundary_type_id]
    });

    this.formGroup.addControl('parcel_identification', createParcelIdentificationFormGroup({
      addInfoOnLand: this.acRetailBuilding.add_info_on_land,
      boundaryType: this.acRetailBuilding.boundary_type_id,
      landParcelName: this.acRetailBuilding.land_parcel_name,
      coordinateReferenceSystemId: this.acRetailBuilding.coordinate_reference_system_id,
      landArea: {
        planningStatusId: this.acRetailBuilding.landArea.planning_status_id,
        qosDegradationId: this.acRetailBuilding.landArea.qos_degradation_id,
        envConsiderations: this.acRetailBuilding.landArea.env_considerations,
        otherConsiderations: this.acRetailBuilding.landArea.other_considerations,
        // TODO
        zoning_comment: null,
        zoning_file_name: null,
        zoning_file_path: null,
        heritage_comment: null,
        heritage_file_name: null,
        heritage_file_path: null
      }
    }));

    const parcelIdentificationForm = this.formGroup.controls.parcel_identification as ParcelIdentificationFormGroup
    formControlValueChanges(parcelIdentificationForm.controls.add_info_on_land).pipe(
      takeUntil(this._onDestroy)
    ).subscribe(val => {
      this._hasParcelInfo$.next(val);
      if (val) {
        parcelIdentificationForm.controls.land_parcel_name.setValidators([Validators.required]);
        parcelIdentificationForm.controls.coordinate_reference_system_id.setValidators([Validators.required]);
      } else {
        parcelIdentificationForm.controls.land_parcel_name.clearValidators();
        parcelIdentificationForm.controls.coordinate_reference_system_id.clearValidators();
      }
      parcelIdentificationForm.controls.land_parcel_name.updateValueAndValidity();
      parcelIdentificationForm.controls.coordinate_reference_system_id.updateValueAndValidity();
    })

    this.formGroup.controls.above_floors.valueChanges.pipe(
      startWith(this.formGroup.controls.above_floors.value),
      takeUntil(this._onDestroy)
    ).subscribe(val => this.aboveFloor$.next(val));

    this.formGroup.controls.below_floors.valueChanges.pipe(
      startWith(this.formGroup.controls.below_floors.value),
      takeUntil(this._onDestroy)
    ).subscribe(val => this.belowFloor$.next(val));

    this.formGroup.controls.sub_type_category_id.valueChanges.pipe(
      startWith(this.formGroup.controls.sub_type_category_id.value),
      takeUntil(this._onDestroy)
    ).subscribe(val => {
      this.filteredSubCategories = this._filterSubCategories(val)

      if (this.filteredSubCategories.length == 0) {
        this.formGroup.controls.sub_category_id.clearValidators();
      } else {
        this.formGroup.controls.sub_category_id.setValidators([Validators.required]);
      }
      this.formGroup.controls.sub_category_id.updateValueAndValidity();
    })
  }
  private _filterSubCategories(stcId: number) {
    if (stcId == null) {
      return [];
    }
    return this.subCategories.filter(item => item.sub_type_category_id == stcId);
  }
  private _updateAssetClass(ac: AssetClassRetailBuildingModel) {
    this.store.dispatch(new AssetClassRetailBuildingOnServerUpdated({
        AssetClassRetailBuilding: ac,
        fileList: this.uploadFileComponent ? this.uploadFileComponent.uploadFiles : []
    }));
    this.layoutUtilsService.showActionNotification('Saved the changes', MessageType.Update, 3000, true, false);
    this.location.back();
  }
  private _createAssetClass(ac: AssetClassRetailBuildingModel) {
    this.store.dispatch(new AssetClassRetailBuildingOnServerCreated({
        AssetClassRetailBuilding: ac,
        fileList: this.uploadFileComponent ? this.uploadFileComponent.uploadFiles : []
    }));
    this.layoutUtilsService.showActionNotification('Saved the changes', MessageType.Create, 3000, true, false);
    this.location.back();
  }
  onTabChanged($event) {
    const activeIndex = $event.index;
  }
  onTabChange(index: number) {
    this.selectedTab = index;
  }
  changeTab(section: string) {
    const section_tab = [
      {sections: ['location', 'parcel'], tab_index: 0},
      {sections: ['prop'], tab_index: 1},
      {sections: ['consideration'], tab_index: 2},
      {sections: ['pic'], tab_index: 3},
    ]
    const active_Tab = section_tab.find(item => item.sections.includes(section));
    this.selectedTab = active_Tab ? active_Tab.tab_index : 0;
    this.selectedtabchange.next(this.selectedTab);
  }
  erroTabMap() {
    return this.typesUtilsService.getCompTabErrorMap(this.isComplexForm, this.error.fields, this.tabHeaders, 11);
  }

  onConsiderationsChange(considerations: AssetClassTenure[]) {
    if (considerations.length > 0) {
      this.considerationError$.next(false)
    } else {
      this.considerationError$.next(undefined)
    }
  }

  onCoordinatePointsChange(points: CoordinatePoint[]) {
    this._points$.next(points)
  }
  onLandAreasChange(items: LandArea[]) {
    this._landAreas$.next(items)
  }

  onCenterChangeV2(event: CoordinatePoint) {
    this.centerLat = event.latitude;
    this.centerLng = event.longitude;
  }
  onMarkerChangeV2(event: CoordinatePoint) {
    if (event == null) {
      return;
    }
    this.markerInfo = { lat: event.latitude, lng: event.longitude, isShow: true };
  }
  private _setLocationInfo() {
    const data = this.acRetailBuilding.locationData;
    if (data.latitude != null) {
      this.centerLat = Number(data.latitude);
    }
    if (data.longitude != null) {
      this.centerLng = Number(data.longitude);
    }
    this.locationInfo = {
      latitude: data.latitude != null ? Number(data.latitude) : null,
      longitude: data.longitude != null ? Number(data.longitude) : null,
      city_id: data.city_id,
      country_id: data.country_id,
      zip_code: data.zip_code,
      unit: data.unit ?? null,
      building_name: data.building_name ?? null,
      sub_community: data.sub_community ?? null,
      streets: data.streets ?? [],
      localities: data.localities ?? [],
      administrative_areas: data.administrative_areas ?? [],
      location_surrounding: data.location_surrounding
    };
  }
}

function _deepCopy(arr: any[]): any[] {
  return arr.map(item => ({...item}));
}
